export const SET_ID_DETAILS_TRANSFER = "SET_ID_DETAILS_TRANSFER"
export const CLEAR_DETAILS_TRANSFER_ID = "CLEAR_DETAILS_TRANSFER_ID"
